import {
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction,
  createContext,
  useContext,
  useMemo,
  useState,
} from 'react';

const ImageListContext = createContext<{
  currentSlidePage: number;
  setCurrentSlidePage: Dispatch<SetStateAction<number>>;
  total: number;
}>({
  currentSlidePage: 1,
  setCurrentSlidePage: () => null,
  total: 1,
});

export function ImageListContextProvider({
  children,
  imagesLength,
}: PropsWithChildren<{readonly imagesLength: number}>) {
  const [currentSlidePage, setCurrentSlidePage] = useState<number>(1);

  // 1ページに4枚表示するので、4で割って切り上げた値をページ数とする
  const total = useMemo(() => Math.ceil(imagesLength / 4), [imagesLength]);

  const provideValue = useMemo(
    () => ({
      currentSlidePage,
      setCurrentSlidePage,
      total,
    }),
    [currentSlidePage, setCurrentSlidePage, total],
  );

  return (
    <ImageListContext.Provider value={provideValue}>
      {children}
    </ImageListContext.Provider>
  );
}

export function useImageListContext() {
  return useContext(ImageListContext);
}
